<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <b-card-code>
                <validation-observer ref="simpleRules">
                  <form @submit.prevent="submitForm">
                    <b-row>
                      <b-col md="4">
                        <b-form-group>
                          <label>Designation</label>
                          <v-select
                            v-model="designation"
                            label="name"
                            placeholder="None"
                            :options="designationOptions"
                            @input="getEmployee(designation.id)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Select Employee</label>
                          <v-select
                            v-model="employee"
                            label="name"
                            placeholder="None"
                            :options="employeeOptions"
                          >
                            <template
                              #option="{ fullname, profile_image, username, surname }"
                            >
                              <b-avatar :src="getprofileImage(profile_image)" />
                              <span class="font-weight-bolder"> {{ fullname }}</span
                              ><span v-if="fullname != 'All'">({{ username }})</span>
                              >
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Select Date</label>
                          <flat-pickr
                            class="form-control"
                            value=""
                            placeholder="Select Date"
                            :config="{
                              dateFormat: 'd/m/Y',
                              mode: 'range',
                            }"
                            style="background-color: transparent"
                            @input="getdata($event)"
                          />
                        </b-form-group>
                      </b-col>
                      <!-- <b-col md="4">
                          <b-form-group>
                            <label>Branch</label>
                            <v-select
                            @input="getEmployee()"
                            v-model="branchname"
                            placeholder="None"
                            label="name"
                            :options="[&quot;Company Associate Partner&quot;,&quot;Franchise&quot;,&quot;Admin&quot;]"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <label>Select Employee</label>
                            <v-select
                            v-model="employee"
                            label="name"
                            placeholder="None"
                            :options="employeeOptions"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <label>Designation</label>
                            <v-select
                            v-model="designation"
                            label="name"
                            placeholder="None"
                            :options="designationOptions"
                            />
                          </b-form-group>
                        </b-col>-->
                    </b-row>
                    <div class="d-flex justify-content-end">
                      <b-button variant="primary" class="ml-2" @click="searchData()">
                        <feather-icon icon="SearchIcon" class="mr-50" />
                        <span class="align-middle">Search</span>
                      </b-button>
                    </div>
                  </form>
                </validation-observer>
              </b-card-code>
              <report-table :data="data" :columns="fields" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/components/axios";
import BCardCode from "@core/components/b-card-code";
import flatPickr from "vue-flatpickr-component";
import ReportTable from "../../../components/ReportTable.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import vSelect from "vue-select";
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BAvatar,
} from "bootstrap-vue";
const baseApi = process.env.VUE_APP_APIENDPOINT;
export default {
  components: {
    vSelect,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BCardCode,
    ReportTable,
    BAvatar,
  },
  data() {
    return {
      designation: "",
      position: "",
      positionOption: [],
      branchname: "",
      employee: "",
      year: "",
      month: "",
      data: "",
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem("accessToken"),
      fields: [
        { field: "id", label: "S.R. No" },
        { field: "name", label: "Employee Name" },
        { field: "machine_code", label: "Machine Code" },
        { rating: true, field: "per_hr_salary", label: "Per Hr Salary" },
        { rating: true, field: "salary", label: "Salary" },
        { rating: true, field: "machine_hours", label: "Machine Hours" },
        { rating: true, field: "employee_hours", label: "Employee Hours" },
        { rating: true, field: "gross_salary", label: "Gross Salary" },
        { rating: true, field: "ot_hr", label: "OT Hr" },
        { rating: true, field: "ot_salary", label: "OT Salary" },
        { field: "holidat_hr", label: "Holiday Hr" },
        { field: "holiday_salary", label: "Holiday Salary" },
        { field: "leaves", label: "Leaves" },
        { field: "net_salary", label: "Net Salary" },
        { field: "print_salary_slip", label: "Print Salary Slip" },
      ],
      employeeOptions: [],
      designationOptions: [],
    };
  },
  mounted() {
    this.getPosition();
  },

  methods: {
    async getPosition(id) {
      await axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getPosition`,
      }).then((response) => {
        this.designationOptions = response.data.data;
      });
    },
    async getEmployee(id) {
      this.employee = null;
      this.employeeOptions = [];
      await axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getPositionWiseEmployee/${id}`,
      }).then((response) => {
        this.employeeOptions = response.data.data;
      });
    },
    getdata(selectedDates) {
      this.result = selectedDates.split(" to ");
      this.startdate = this.result[0];
      this.enddate = this.result[1];
    },

    async searchData(tableData) {
      const data = {
        startdate: this.startdate,
        enddate: this.enddate,
        designation: this.designation.id,
        employee_id: this.employee.id,
      };
      await axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify(data),
        url: `${this.baseApi}/employeeperformancereport`,
      }).then((response) => {
        this.data = response.data.data;
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
